import { useMemo } from 'react';
import type { AppProps } from 'next/app';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import { useRouter } from 'next/router';
import i18n from '../i18n';
import theme from '../styles/theme';
import '../styles/booking.css';

export default function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const locale = router.locale || 'pl';
  const translations = useMemo(() => i18n.cloneInstance({ lng: locale, initImmediate: false }), [locale]);

  return (
    <I18nextProvider i18n={translations}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...pageProps} />
      </ThemeProvider>
    </I18nextProvider>
  );
}
